import React, { useState } from 'react';
import clsx from 'clsx';
import {
	FingotiButton,
	FingotiModalActions,
	FingotiModalContent,
} from '@fingoti/components';
import { useSnackbar } from 'notistack';

import makeStyles from '@material-ui/core/styles/makeStyles';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';

import Validation from '../../../services/validation.service';
import { useForceUpdate } from '../../utils/ForceUpdate';
import { apiService } from '../../../services/api.service';

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		justifyContent: 'center',
	},
	form: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		[theme.breakpoints.up('md')]: {
			width: '60%',
		},
	},
	headerCell: {
		border: 'none',
		textAlign: 'right',
		borderRight: '1px solid ' + theme.palette.greyFour.main,
		width: '10%',
		color: theme.palette.greyTwo.main,
		[theme.breakpoints.down('md')]: {
			paddingLeft: 0,
			paddingRight: theme.spacing(2),
		},
	},
	noBottomBorder: {
		border: 'none',
		textAlign: 'center',
	},
	formControl: {
		width: '100%',
	},
	halfWidth: {
		width: '48%',
	},
	buttonGroup: {
		display: 'flex',
		justifyContent: 'space-evenly',
		width: '100%',
		[theme.breakpoints.up('md')]: {
			width: '50%',
		},
	},
	button: {
		width: '42%',
	},
}));

export const ConfigAdd = ({ setOpen, onSuccess }) => {
	const classes = useStyles();
	const forceUpdate = useForceUpdate();
	const { enqueueSnackbar } = useSnackbar();
	const [configName, setConfigName] = useState('');
	const [disabled, setDisabled] = useState(false);
	const [priSSID, setPriSSID] = useState('');
	const [priPass, setPriPass] = useState('');
	const [errors, setErrors] = useState([]);

	const submitConfig = () => {
		let body = {
			presetName: configName,
			disabled: disabled,
			ssid: priSSID,
			password: priPass,
		};

		apiService
			.postData('/organisation/presets', body)
			.then((result) => {
				enqueueSnackbar(result.message, { variant: 'success' });
				onSuccess();
			})
			.catch((error) => {
				enqueueSnackbar(error, { variant: 'error' });
			});
	};

	const handleSetErrors = (errors) => {
		setErrors(errors);
		forceUpdate();
	};

	const validate = new Validation(errors, handleSetErrors);

	return (
		<>
			<FingotiModalContent>
				<div className={classes.root}>
					<div className={classes.form}>
						<Grid container spacing={2}>
							<Grid item xs={12}>
								<FormControl variant='outlined' className={classes.formControl}>
									<TextField
										fullWidth
										required
										id='presetName'
										name='presetName'
										variant='outlined'
										label='preset name'
										value={configName}
										onChange={(e) => setConfigName(e.target.value)}
										onBlur={(e) => validate.checkNotEmpty(e)}
										error={Boolean(errors['presetName'])}
										helperText={
											Boolean(errors['presetName'])
												? errors['presetName'].msg
												: ''
										}
									/>
								</FormControl>
							</Grid>
							<Grid item xs={12}>
								<div className={classes.formControl}>
									<FormControl required variant='outlined'>
										<FormControlLabel
											control={
												<Switch
													checked={!disabled}
													onChange={() => setDisabled(!disabled)}
													name='disabled'
													color='primary'
												/>
											}
											label='enabled'
										/>
									</FormControl>
								</div>
							</Grid>
							<Grid item xs={12} md={6}>
								<FormControl variant='outlined' className={classes.formControl}>
									<TextField
										required
										id='ssid'
										name='ssid'
										variant='outlined'
										label='ssid'
										value={priSSID}
										onChange={(e) => {
											setPriSSID(e.target.value);
										}}
										onBlur={(e) => validate.checkNotEmpty(e)}
										error={Boolean(errors['ssid'])}
										helperText={
											Boolean(errors['ssid']) ? errors['ssid'].msg : ''
										}
									/>
								</FormControl>
							</Grid>
							<Grid item xs={12} md={6}>
								<FormControl variant='outlined' className={classes.formControl}>
									<TextField
										required
										type='password'
										name='password'
										id='password'
										variant='outlined'
										label='password'
										value={priPass}
										onChange={(e) => setPriPass(e.target.value)}
										onBlur={(e) => {
											if (e.target.value.length > 7) {
												validate.checkNotEmpty(e);
											} else {
												errors['password'] = {
													msg: 'password must be at least 8 characters',
												};
												handleSetErrors(errors);
											}
										}}
										error={Boolean(errors['password'])}
										helperText={
											Boolean(errors['password']) ? errors['password'].msg : ''
										}
									/>
								</FormControl>
							</Grid>
						</Grid>
					</div>
				</div>
			</FingotiModalContent>
			<FingotiModalActions>
				<div className={classes.buttonGroup}>
					<FingotiButton
						light
						type='submit'
						color='primary'
						disabled={Boolean(
							Object.keys(errors).length > 0 ||
								configName.length === 0 ||
								priSSID.length === 0 ||
								priPass.length < 8
						)}
						className={classes.button}
						onClick={submitConfig}>
						create preset
					</FingotiButton>
					<FingotiButton
						light
						className={classes.button}
						onClick={() => setOpen(false)}>
						Cancel
					</FingotiButton>
				</div>
			</FingotiModalActions>
		</>
	);
};
